import React, { ReactElement } from 'react';
import { Spin } from 'antd';

import { LoadingPageWrapper } from './loadingPage.styles';

function LoadingPage(): ReactElement {
  return (
    <LoadingPageWrapper>
      <Spin />
    </LoadingPageWrapper>
  );
}

export default LoadingPage;
